<template>
  <div class="contact-us full-screen">
    <div class="wrapper wrapper-full-page section content bg-secondary">
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3">
            <div class="mt-5 d-flex justify-content-center">
              <div class="card">
                <div class="card-body">
                  <h1 class="card-title mb-4" style="font-size: 1.75em;">Έναρξη επαναφοράς κωδικού</h1>
                  <p>Πληκτρολογήστε το email σας για να σας στείλουμε τον σύνδεσμο επαναφοράς κωδικού</p>
                  <div class="form-group">
                    <label class="control-label" for="email_input">Email</label>
                    <input class="form-control" id="email_input" type="email" v-model.trim="email" required>
                  </div>
                </div>
                <div class="card-footer">
                  <div class="text-center">
                    <button class="btn btn-block btn-success" @click="send" :disabled="loading">Αποστολη<span v-if="loading">...</span></button>
                    <div v-if="errorMsg !== ''" class="text-danger mt-1">{{ errorMsg }}</div>
                  </div>
                  <div class="text-center mt-4">
                    <div class=""><router-link :to="{path:'/login'}">επιστροφή</router-link></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Api from "../api";
export default {
  data() {
    return {
      email: "",
      errorMsg: "",
      loading: false
    };
  },
  methods: {
    send () {
      if (this.email === "") {
        return false;
      }
      this.loading = true;
      Api.send2("POST", "/user/reset/password/send", {email: this.email}, '')
      .then((response) => {
        this.errorMsg = "";
        this.$router.push({name: 'reset_password_send_success'})
      })
      .catch((err) => {
        this.errorMsg = err.msg;
      })
      .finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>
<style></style>
